import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, inject, OnInit, Output, signal } from '@angular/core';
import { ListBanksService } from './service/list-banks.service';
import { BankData, ListBanksResponse } from './interfaces/list-banks.interface';

import { FormsModule } from '@angular/forms';

@Component({
  selector: 'list-banks',
  imports: [CommonModule, FormsModule],
  templateUrl: './list-banks.component.html',
  styleUrl: './list-banks.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListBanksComponent implements OnInit {

  listBanksService = inject(ListBanksService);
  banks = signal<BankData[]>([]);

  // Selected bank model for ngModel binding
  selectedBankModel: BankData | null = null;

  @Output() selectedBank = new EventEmitter<BankData>();

  ngOnInit(): void {
    this.loadBanks();
  }

  loadBanks(): void {
    this.listBanksService.loadListBanks().pipe().subscribe({
      next: (response: ListBanksResponse) => {
        // console.log(response);
        this.banks.set(response.data);
      },
      error: (error) => {
        this.banks.set([]);
      }
    });
  }

  onSelectBank(bank: BankData): void {
    this.selectedBankModel = bank;
    this.selectedBank.emit(bank);
  }
}
